import { memo, ReactNode } from "react";

import BoxContainer from "@hl/base-components/lib/BoxContainer";
import { PlusCircle } from "@hl/base-components/lib/assets/icons.generated";
import { UTILITY_COLOR } from "@hl/base-components/lib/theme/colors";
import { Box, Button, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";

const NoWalletMessage = ({
  header,
  entity,
  redirectUrl,
}: {
  header?: ReactNode;
  entity: string;
  redirectUrl: string;
}) => (
  <BoxContainer
    radius={20}
    border={false}
    pt={160}
    pb={240}
    bg={UTILITY_COLOR.TABLE_ROW_BACKGROUND}
  >
    <Stack spacing={32} align="center">
      <Stack spacing={16} align="center">
        {header}
        <Title order={5}>{`Create your first ${entity}`}</Title>
        <Text size="sm">
          {`You haven’t created any ${entity}s yet. Once you do, all your ${entity}s will appear here.`}
        </Text>
      </Stack>
      <Box w={240}>
        <Button
          fullWidth
          component={Link}
          to={redirectUrl}
          leftIcon={<PlusCircle />}
          size="lg"
        >
          {`Create a ${entity}`}
        </Button>
      </Box>
    </Stack>
  </BoxContainer>
);

export default memo(NoWalletMessage);
